export class NonAisStudent {
    family_name: string;
    given_name: string;
    known_name: string;
    gender: string;
    date_of_birth: string;
    country: string;
    medical: StudentMedical[];
    constructor(){
        this.family_name = ''
        this.given_name = ''
        this.known_name = ''
        this.gender = ''
        this.date_of_birth = ''
        this.country = ''
        this.medical = []
        this.medical[0] = {
          under_doctor_care: "",
          medication: "",
          allergic: "",
          limit_paticipation_athlentic: "",
          special_education_needs: "",
          special_education_support: "",
        };
    }
}

export class StudentMedical {
    under_doctor_care: string;
    medication: string;
    allergic: string;
    limit_paticipation_athlentic: string;
    special_education_needs: string;
    special_education_support: string;
    constructor() {
        this.under_doctor_care = "";
        this.medication = "";
        this.allergic = "";
        this.limit_paticipation_athlentic = "";
        this.special_education_needs = "";
        this.special_education_support = "";
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/models/NonAisStudent.ts